//-------------------------------------------------------------------------------------------------
export interface AppConfig {
  apiUrl: string;
  clientId: string;
  tenantId: string;
}
//-------------------------------------------------------------------------------------------------
export interface IConfigService {
  loadConfig(url: string): Promise<AppConfig>;
  loadConfig(): Promise<AppConfig>;
  getConfig(): AppConfig | null;
  get apiUrl(): string | null;
  get clientId(): string | null;
  get tenantId(): string | null;
  get edgeOsMopBaseUrl(): string | null;
}
//-------------------------------------------------------------------------------------------------
class ConfigServiceClass implements IConfigService {
  private static instance: ConfigServiceClass;
  private config!: AppConfig;
  //-------------------------------------------------------------------------------------------------
  private constructor() { }
  //-------------------------------------------------------------------------------------------------
  public static getInstance(): ConfigServiceClass {
    if (!ConfigServiceClass.instance) {
      ConfigServiceClass.instance = new ConfigServiceClass();
    }
    return ConfigServiceClass.instance;
  }
  //-------------------------------------------------------------------------------------------------
  public async loadConfig(url: string = '/appconfig.json'): Promise<AppConfig> {
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to load config from ${url}: ${res.statusText}`);
    }
    this.config = await res.json();
    return this.config;
  }
  //-------------------------------------------------------------------------------------------------
  // Access config safely
  public getConfig(): AppConfig | null {
    if (!this.config) {
      return null;
    }
    return this.config;
  }
  //-------------------------------------------------------------------------------------------------
  // Convenience getters
  public get apiUrl(): string {
    if (import.meta.env.VITE_BACKEND_URL != null) {
      return import.meta.env.VITE_BACKEND_URL;
    }
    // Read before loadConfig() resolves (axiosInstance module init) — fall back to same-origin.
    const config = this.getConfig();
    if (config?.apiUrl != null) {
      return config.apiUrl;
    }
    return `${window.location.protocol}//${window.location.host}/`
  }
  //-------------------------------------------------------------------------------------------------
  public get clientId(): string {
    if (import.meta.env.VITE_ENTRA_CLIENT_ID != null) {
      return this.getConfig()!.clientId;
    }
    return import.meta.env.VITE_ENTRA_CLIENT_ID;
  }
  //-------------------------------------------------------------------------------------------------
  public get tenantId(): string | null {
    if (import.meta.env.VITE_ENTRA_TENANT_ID != null) {
      return import.meta.env.VITE_ENTRA_TENANT_ID
    }
    if (!this.getConfig()) return null;
    return this.getConfig()!.tenantId;
  }
  //-------------------------------------------------------------------------------------------------
  public get edgeOsMopBaseUrl(): string | null {
    return import.meta.env.VITE_EDGEOS_MOP_BASE_URL ?? null;
  }
}
//-------------------------------------------------------------------------------------------------
export const ConfigService: IConfigService = ConfigServiceClass.getInstance();

